// extracted by mini-css-extract-plugin
export default {"white_label":"TableSortLabel_white_label__fdhcH"};